export default __webpack_public_path__ + "static/media/symbol-enter-provider.a96ceb61.svg";